import store from '@/store'
import { DirectiveOptions, DirectiveFunction } from 'vue'
import { DirectiveBinding } from 'vue/types/options'
import * as graph from '@shared/types/graphql'

interface DirectiveElement extends HTMLElement {
  '__role_unwatch__'?: () => void
}

const aclAction = (binding: DirectiveBinding, el: DirectiveElement) => {
  // save original display state
  const originDisplayVal = el.style.display

  el.style.display = 'none'

  if (!store.state.user.acl || !store.state.user.acl.permissions) return

  // stupid because graphql cant hypen
  const resource = binding.value.replace(/-([a-z])/g, (g: any) => g[1].toUpperCase()) as keyof graph.PermissionsObject

  const resourceActions = store.state.user.acl.permissions[resource]

  if (!resourceActions || !resourceActions.length) return

  const allowed = binding.arg ? resourceActions.indexOf(binding.arg) !== -1 : false

  if (binding.arg === 'view' && allowed) {
    el.style.display = originDisplayVal
  }
}

const aclHandle: DirectiveFunction = (el: DirectiveElement, binding, vnode) => {
  const unwatch = store.original.watch(() => store.state.user.acl, (value, oldvalue) => {
    aclAction(binding, el)
  })
  el.__role_unwatch__ = unwatch

  aclAction(binding, el)
}

const directiveOptions: DirectiveOptions = {
  inserted: aclHandle,
  unbind (el: DirectiveElement) {
    if (!el.__role_unwatch__) return
    el.__role_unwatch__()
  }
}
export default directiveOptions
